import { render, staticRenderFns } from "./AssistantView.vue?vue&type=template&id=5288753e&scoped=true"
import script from "./AssistantView.vue?vue&type=script&lang=ts"
export * from "./AssistantView.vue?vue&type=script&lang=ts"
import style0 from "./AssistantView.vue?vue&type=style&index=0&id=5288753e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5288753e",
  null
  
)

export default component.exports